import { render, staticRenderFns } from "./termsAgreement.vue?vue&type=template&id=272fcd12&"
import script from "./termsAgreement.vue?vue&type=script&lang=js&"
export * from "./termsAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports